import React, { useState, useEffect } from "react";
import Tooltip from "./Tooltip";
import logo from "../assets/img/logo.png";


function Header() {
  const [openMenus, setOpenMenus] = useState({});
  const [isMobile, setIsMobile] = useState(true);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 991);
      if (window.innerWidth > 991) {
        setMobileMenuOpen(false);
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleMenuHover = (menuKey, isOpen) => {
    setOpenMenus((prev) => ({ ...prev, [menuKey]: isOpen }));
  };

  // Cierra todos los submenús en mobile al hacer click en un enlace
  const handleSubmenuLinkClick = () => {
    if (isMobile) {
      setOpenMenus({});
      setMobileMenuOpen(false);
    }
  };

  return (
    <div className="header header-light">
      <div className="container">
        <nav id="navigation" className={`navigation ${isMobile ? "navigation-portrait" : "navigation-landscape"}`}>
          <div className="nav-header">
            <a className="nav-brand" href="/">
              <img src={logo} className="logo" alt="" />
            </a>
            <div className="nav-toggle" onClick={() => setMobileMenuOpen((open) => !open)}></div>
          </div>
          <div className={isMobile ? `nav-menus-wrapper${mobileMenuOpen ? " nav-menus-wrapper-open" : ""}` : "nav-menus-wrapper"}>
            <span className="nav-menus-wrapper-close-button" onClick={() => setMobileMenuOpen(false)}>✕</span>
            <ul className="nav-menu">
              {isMobile && (
                <li>
                  <a href="/">
                    <i className="bi bi-house me-2"></i>
                    Inicio
                  </a>
                </li>
              )}
              <li
                className="active"
                onMouseEnter={() => handleMenuHover("about-us", true)}
                onMouseLeave={() => handleMenuHover("about-us", false)}
              >
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a href="#">
                  {isMobile ? (<i className="bi bi-people-fill me-2"></i>) : null}
                  Nosotros
                  <span className="submenu-indicator">
                    <span className="submenu-indicator-chevron"></span>
                  </span>
                </a>
                <ul
                  className="nav-dropdown nav-submenu"
                  style={{
                    right: "auto",
                    display: openMenus["about-us"] ? "block" : "none",
                  }}
                >
                  <li>
                    <a href="/historia" onClick={handleSubmenuLinkClick}>Historia</a>
                  </li>
                  <li>
                    <a href="/mision-y-vision" onClick={handleSubmenuLinkClick}>Misión y Visión</a>
                  </li>
                  <li>
                    <a href="/nuestra-sede" onClick={handleSubmenuLinkClick}>Nuestra Sede</a>
                  </li>
                </ul>
              </li>
              <li
                onMouseEnter={() => handleMenuHover("carrers", true)}
                onMouseLeave={() => handleMenuHover("carrers", false)}
              >
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a href="#">
                  {isMobile ? (<i className="bi bi-book me-2"></i>) : null}
                  Estudios
                  <span className="submenu-indicator">
                    <span className="submenu-indicator-chevron"></span>
                  </span>
                </a>
                <ul
                  className="nav-dropdown nav-submenu"
                  style={{ display: openMenus["carrers"] ? "block" : "none" }}
                >
                  {/* <li
                    onMouseEnter={() => handleMenuHover("in-person", true)}
                    onMouseLeave={() => handleMenuHover("in-person", false)}
                  >
                    <a href="#">
                      Técnico Superior Universitario
                      <span className="submenu-indicator">
                        <span className="submenu-indicator-chevron"></span>
                      </span>
                    </a>
                    <ul
                      className="nav-dropdown nav-submenu"
                      style={{
                        display: openMenus["in-person"] ? "block" : "none",
                      }}
                    > */}
                      <li>
                        <a
                          href="/carreras/administracion-de-empresas"
                          className="nav-link-flex"
                          onClick={handleSubmenuLinkClick}
                        >
                          Administración de Empresas{" "}
                          <Tooltip text="Carrera disponible presencial y multimodal">
                            <i className="bi bi-person-workspace" />
                          </Tooltip>
                        </a>
                      </li>
                      <li>
                        <a href="/carreras/administracion-de-personal" onClick={handleSubmenuLinkClick}>
                          Administración de Personal
                        </a>
                      </li>
                      <li>
                        <a href="/carreras/administracion-de-sistemas-de-mantenimiento" onClick={handleSubmenuLinkClick}>
                          Administración de Sistemas de Mantenimiento
                        </a>
                      </li>
                      <li>
                        <a
                          href="/carreras/administracion-tributaria"
                          className="nav-link-flex"
                          onClick={handleSubmenuLinkClick}
                        >
                          Administración Tributaria
                          <Tooltip text="Carrera disponible presencial y multimodal">
                            <i className="bi bi-person-workspace" />
                          </Tooltip>
                        </a>
                      </li>
                      <li>
                        <a
                          href="/carreras/higiene-y-seguridad-industrial"
                          className="nav-link-flex"
                          onClick={handleSubmenuLinkClick}
                        >
                          Higiente y Seguridad Industrial
                          <Tooltip text="Carrera disponible presencial y multimodal">
                            <i className="bi bi-person-workspace" />
                          </Tooltip>
                        </a>
                      </li>
                      <li>
                        <a
                          href="/carreras/informatica"
                          className="nav-link-flex"
                          onClick={handleSubmenuLinkClick}
                        >
                          Informática
                          <Tooltip text="Carrera disponible presencial y multimodal">
                            <i className="bi bi-person-workspace" />
                          </Tooltip>
                        </a>
                      </li>
                      <li>
                        <a
                          href="/carreras/logistica-industrial"
                          className="nav-link-flex"
                          onClick={handleSubmenuLinkClick}
                        >
                          Logística Industrial
                          <Tooltip text="Carrera disponible presencial y multimodal">
                            <i className="bi bi-person-workspace" />
                          </Tooltip>
                        </a>
                      </li>
                      <li>
                        <a
                          href="/carreras/tecnologia-de-gas"
                          className="nav-link-flex"
                          onClick={handleSubmenuLinkClick}
                        >
                          Tecnología de Gas
                          <Tooltip text="Carrera disponible presencial y multimodal">
                            <i className="bi bi-person-workspace" />
                          </Tooltip>
                        </a>
                      </li>
                      <li>
                        <a href="/carreras/tecnologia-instrumentista" onClick={handleSubmenuLinkClick}>
                          Tecnología Instrumentista
                        </a>
                      </li>
                      <li>
                        <a
                          href="/carreras/tecnologia-petrolera"
                          className="nav-link-flex"
                          onClick={handleSubmenuLinkClick}
                        >
                          Tecnología Petrolera
                          <Tooltip text="Carrera disponible presencial y multimodal">
                            <i className="bi bi-person-workspace" />
                          </Tooltip>
                        </a>
                      </li>
                    </ul>
                  </li>
                  {/* <li>
                    <a href="/ingenieria-y-licenciatura">
                      Ingeniería y Licenciatura
                    </a>
                  </li>
                  <li>
                    <a href="/diplomados">Diplomados</a>
                  </li>
                  <li>
                    <a href="/cursos">Cursos</a>
                  </li> */}


                {/* </ul>
              </li> */}
              

              {/* <li
                className="active"
                onMouseEnter={() => handleMenuHover("inscripciones", true)}
                onMouseLeave={() => handleMenuHover("inscripciones", false)}
              > */}
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                {/* <a href="#">
                  {isMobile ? (<i className="bi bi-pencil-square me-2"></i>) : null}
                  Inscripciones
                  <span className="submenu-indicator">
                    <span className="submenu-indicator-chevron"></span>
                  </span>
                </a>
                <ul
                  className="nav-dropdown nav-submenu"
                  style={{
                    right: "auto",
                    display: openMenus["inscripciones"] ? "block" : "none",
                  }}
                >
                  <li>
                    <a href="/admision" onClick={handleSubmenuLinkClick}>Nuevos ingresos</a>
                  </li>
                  <li>
                    <a href="/inscripcion" onClick={handleSubmenuLinkClick}>Inscripción de alumnos regulares</a>
                  </li>
                </ul>
              </li> */}
              <li>
                <a href="/admision">
                  {isMobile ? (<i className="bi bi-pencil-square me-2"></i>) : null}
                  Nuevos ingresos
                </a>
              </li>
              <li>
                <a href="/preguntas-frecuentes">
                  {isMobile ? (<i className="bi bi-question-circle me-2" style={{ transform: "none" }}></i>) : null}
                  Preguntas Frecuentes
                </a>
              </li>
              {isMobile && (
                <>
                  <li>
                    <a href="https://iutaplcvirtual.com" target="_blank" rel="noreferrer">
                      <i className="bi bi-box-arrow-in-right me-2"></i>
                      Campus Virtual
                    </a>
                  </li>
                  <li>
                    <a href="https://iuta.terna.net" target="_blank" rel="noreferrer">
                      <i className="bi bi-person-circle me-2"></i>
                      TernaNet
                    </a>
                  </li>
                </>
              )}
            </ul>
            <ul className="nav-menu nav-menu-social align-to-right">
              <li className="become-tutor">
                <a
                  href="https://iutaplcvirtual.com"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="bi bi-box-arrow-in-right"></i>Campus Virtual
                </a>
              </li>
              <li className="join-btn">
                <a
                  href="https://iuta.terna.net"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="bi bi-person-circle"></i>TernaNet
                </a>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </div>
  );
}

export default Header;
